import React, { memo } from "react"

import { Slider, TextInput } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { func, number, oneOf, oneOfType, string } from "prop-types"

function NumericControl({
  id,
  label,
  min,
  max,
  step,
  value = 0,
  inputSize,
  sliderSize = "small",
  onSliderChange: handleSliderChange,
  onInputChange: handleInputChange,
}) {
  return (
    <div className="environment-settings__field environment-settings__field--slider">
      <span className="environment-settings__label cgt-body-base-semibold">{label}</span>
      <div className="environment-settings__slider-row">
        <Slider
          hideRangeValues
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleSliderChange}
          wrapperClassName="environment-settings__slider"
          size={sliderSize}
        />
        <TextInput
          id={id}
          isPilot
          size={inputSize}
          inputType="number"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={event => handleInputChange(event.target.value)}
          textInputClassName="environment-settings__input cgt-body-base"
        />
      </div>
    </div>
  )
}

NumericControl.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  min: number.isRequired,
  max: number.isRequired,
  step: number.isRequired,
  value: oneOfType([number, string]),
  inputSize: oneOf(["tiny", "small"]).isRequired,
  sliderSize: oneOf(["tiny", "small"]),
  onSliderChange: func.isRequired,
  onInputChange: func.isRequired,
}

export default memo(NumericControl)
